module.exports = __webpack_public_path__ + "./Flex_6faa8e6f6d908d57e29df08608ba562a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Flex.jpg
// module id = 526
// module chunks = 0